import { OverlayRef } from '@angular/cdk/overlay';
import { EventEmitter } from '@angular/core';

import { PopupMenuConfig } from './popup-menu.config';
import { PopupMenuItem } from './popup-menu-item.model';
import { ColoredPopupMenuItem } from './colored-popup-menu-item.model';

export enum CloseEventType
{
    Outside = -1,
    TimeOut = 0,
    Clicked = 1
}

export class PopupMenuRef
{
    public closeEvent: EventEmitter<CloseEventType> = new EventEmitter<CloseEventType>();

    constructor (
        public popupMenuItems: PopupMenuItem[] | ColoredPopupMenuItem[],
        public readonly overlayRef: OverlayRef,
        public config: PopupMenuConfig
    )
    {
    }

    myGetBoundingClientRect (): ClientRect
    {
        return this.overlayRef.overlayElement.getBoundingClientRect();
    }

    isVisible ()
    {
        return this.overlayRef && this.overlayRef.overlayElement !== null;
    }

    close (type: CloseEventType = CloseEventType.Clicked)
    {
        this._close(type);
    }

    private _close (type: CloseEventType )
    {
        this.overlayRef.dispose();
        this.closeEvent.emit(type);
    }
}
